import { CSSProperties } from "react";

export type PaymentusSetupItemTypeName =
  | "saveInWallet"
  | "bankAccountNumber"
  | "bankRoutingNumber"
  | "bankAccountNumberConfirmation";
export type PaymentusSetupItemType = {
  /**
   * Property to set a row index to the specific element
   */
  row: number;
  /**
   * Title for specific input
   */
  label: string;
  /**
   * Name for specific input
   */
  name?: PaymentusSetupItemTypeName;
  /**
   * The className to be used for set styles for non stripe elements
   */
  className?: string;
  /**
   * Property for set an input's placeholder
   */
  placeholder?: string;
};

/**
 * PaymentusSetupType
 */
export type PaymentusSetupType = {
  /**
   * Object represents bankAccountNumber input
   */
  bankRoutingNumber?: PaymentusSetupItemType;
  /**
   * Object represents bankAccountNumber input
   */
  bankAccountNumber?: PaymentusSetupItemType;
  /**
   * Object represents bankConfirmAccountNumber input
   */
  bankAccountNumberConfirmation?: PaymentusSetupItemType;
  /**
   * Object represents saveInWallet checkbox input
   */
  saveInWallet?: PaymentusSetupItemType;
};
export const PaymentusDefaultSetup: PaymentusSetupType = {
  bankRoutingNumber: {
    label: "Routing Number",
    row: 0,
    className: "col-start-1 col-end-7",
  },
  bankAccountNumber: {
    row: 1,
    label: "Account Number",
    className: "col-start-1 col-end-7",
  },
};

export type PaymentusFormStyles = {
  paymentusContainer?: CSSProperties;
  paymentusInputsContainer?: CSSProperties;
  paymentusTextInputContainer?: CSSProperties;
  textLabel?: CSSProperties;
  formField?: CSSProperties;
  inputElement?: CSSProperties;
};
